import '../../App.css';
import "./PaymentMethods.css";
import { useState, useEffect } from 'react';
import { Modal, Input, Table, Upload, Button, Switch, Image } from 'antd';
import axios from 'axios';
import Appconfig from '../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { UploadOutlined } from '@ant-design/icons';


function PaymentMethods() {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openBanner, setOpenBanner] = useState(false)
    const [button, setButton] = useState(false)
    const [fileList, setFileList] = useState([]);
    const [banners, setBanners] = useState([])
    const [id, setId] = useState('')
    const [paymentType, setPaymentType] = useState(""); // State to track selected payment type
    const [formData, setFormData] = useState({
        user_id: userInfo?._id,
        site_code: Appconfig.sitecodes,
        accountNo: "",
        accountHolder: "",
        ifscCode: "",
        bankName: "",
        upiId: "",
        holderName: ""
    });

    const [AcNumValidationError, setAcNumValidationError] = useState("Please enter account number");
    const [AcHolderValidationError, setAcHolderValidationError] = useState("Please enter account holder name");
    const [IfscValidationError, setIfscValidationError] = useState("Please enter ifsc code");
    const [BankValidationError, setBankValidationError] = useState("Please enter bank name");
    const [UPIValidationError, setUPIValidationError] = useState("Please enter id");
    const [HolderValidationError, setHolderValidationError] = useState("Please enter holder name");

    const [paymentMethod, setPatmentMethod] = useState([]);


    const handleSetFormData = (event) => {
        // If USDT, store wallet address in upiId
        if (paymentType === "USDT" && event.target.name === "usdtAddress") {
            setFormData({
                ...formData,
                upiId: event.target.value
            });
        } else {
            setFormData({
                ...formData,
                [event.target.name]: event.target.value,
            });
        }
    };


    const handlePaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
    };

    const openAddMethodModal = () => {
        setPaymentType("");

        setFormData({
            user_id: userInfo?._id,
            site_code: Appconfig.sitecodes,
            accountNo: "",
            accountHolder: "",
            ifscCode: "",
            bankName: "",
            upiId: "",
            holderName: "",
        });

        setFileList([]);
        setOpenBanner(true);
    };

    const closeAddMethodModal = () => {
        if (button) {
            return;
        }

        setOpenBanner(false);
    };




    function deleteType(id) {
        setButton(true)
        var data = JSON.stringify({
            id: id,
        });
        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}paymentMethod/deleteType`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                NotificationManager.success(response.data.resultMessage, '', 3000);
                getPaymentDetails();
                setButton(false)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function statusUpdate(id, status) {
        setButton(true)
        var data = JSON.stringify({
            id: id,
            status: status == "Active" ? "Inactive" : "Active"
        });
        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}paymentMethod/statusUpdate`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                NotificationManager.success(response.data.resultMessage, '', 3000);
                getPaymentDetails();
                setButton(false)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function editNews(id, message) {
        setOpenBanner(true);
        setId(id);

    }


    const columns = [
        {
            title: "Type",
            key: "type",
            dataIndex: "type",
            sorter: (first, second) =>
                String(first?.type || "")
                    .localeCompare(
                        String(second?.type || "")
                    ),
            render: (value) => (
                <span className="payment-type-badge">
                    {value || "-"}
                </span>
            ),
        },
        {
            title: "Holder Name",
            key: "holderName",
            sorter: (first, second) =>
                String(
                    first?.type === "Bank"
                        ? first?.accountHolder
                        : first?.holderName
                ).localeCompare(
                    String(
                        second?.type === "Bank"
                            ? second?.accountHolder
                            : second?.holderName
                    )
                ),
            render: (_, record) => (
                <span className="payment-table-primary">
                    {record?.type === "Bank"
                        ? record?.accountHolder || "-"
                        : record?.holderName || "-"}
                </span>
            ),
        },
        {
            title:
                "UPI ID / Account No / USDT Wallet Address",
            key: "paymentDetails",
            sorter: (first, second) =>
                String(
                    first?.type === "Bank"
                        ? first?.accountNo
                        : first?.upiId
                ).localeCompare(
                    String(
                        second?.type === "Bank"
                            ? second?.accountNo
                            : second?.upiId
                    )
                ),
            render: (_, record) => {
                if (record?.type === "QRCODE") {
                    return record?.qrCode ? (
                        <Image
                            width={58}
                            height={58}
                            preview
                            className="payment-qr-image"
                            src={`${Appconfig.apiUrl}banner/${record.qrCode}`}
                        />
                    ) : (
                        "-"
                    );
                }

                return (
                    <span className="payment-detail-value">
                        {record?.type === "Bank"
                            ? record?.accountNo || "-"
                            : record?.upiId || "-"}
                    </span>
                );
            },
        },
        {
            title: "IFSC Code",
            key: "ifscCode",
            dataIndex: "ifscCode",
            sorter: (first, second) =>
                String(first?.ifscCode || "")
                    .localeCompare(
                        String(
                            second?.ifscCode || ""
                        )
                    ),
            render: (value) => (
                <span className="payment-table-secondary">
                    {value || "-"}
                </span>
            ),
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            sorter: (first, second) =>
                String(first?.status || "")
                    .localeCompare(
                        String(
                            second?.status || ""
                        )
                    ),
            render: (status) => (
                <span
                    className={
                        status === "Active"
                            ? "payment-status active"
                            : "payment-status inactive"
                    }
                >
                    {status || "Inactive"}
                </span>
            ),
        },
        {
            title: "Action",
            key: "action",
            width: 150,
            render: (_, record) => (
                <div className="payment-actions">
                    <button
                        type="button"
                        disabled={button}
                        className="payment-delete-button"
                        title="Delete payment method"
                        aria-label="Delete payment method"
                        onClick={() =>
                            deleteType(record._id)
                        }
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 26 26"
                            aria-hidden="true"
                        >
                            <path
                                fill="currentColor"
                                d="M16.162.213H9.838C9.358.535 9.005 1.049 8.78 1.821H2.233c-.191 0-.32.097-.32.29v2.541c0 .193.129.29.32.322h21.534c.224-.032.32-.129.32-.322V2.111c0-.193-.097-.29-.32-.29h-6.514c-.258-.772-.61-1.286-1.091-1.608z"
                            />

                            <path
                                fill="currentColor"
                                d="M19.725 25.788c1.088-.453 1.698-1.256 1.795-2.415v-.097l1.058-16.694H3.454l1.027 16.694c0 .035 0 .065.031.097.096 1.159.674 1.962 1.765 2.415h13.448z"
                            />
                        </svg>
                    </button>

                    <Switch
                        checked={
                            record?.status ===
                            "Active"
                        }
                        loading={button}
                        aria-label={`${record?.status ===
                            "Active"
                            ? "Deactivate"
                            : "Activate"
                            } payment method`}
                        onChange={() =>
                            statusUpdate(
                                record._id,
                                record.status
                            )
                        }
                    />
                </div>
            ),
        },
    ];

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    function checkValidation() {

        if (paymentType == "Bank") {
            if ((formData.accountNo || "").trim() === "") {
                setAcNumValidationError('Please enter account number')
                document.querySelector('.acnum').classList.remove('hidden');
            }
            if ((formData.accountHolder || "").trim() === "") {
                setAcHolderValidationError('Please enter holder name')
                document.querySelector('.acholder').classList.remove('hidden');
            }
            if ((formData.ifscCode || "").trim() === "") {
                setIfscValidationError('Please enter ifsc code')
                document.querySelector('.ifsccode').classList.remove('hidden');
            }

            if ((formData.bankName || "").trim() === "") {
                setBankValidationError('Please enter bank name')
                document.querySelector('.bankname').classList.remove('hidden');
            }

            if ((formData.accountNo || "") !== "" && (formData.accountHolder || "") !== "" && (formData.ifscCode || "") !== "" && (formData.bankName || "") !== "") {
                return true
            }
            return false;
        } else if (paymentType == "QRCODE") {

            if (fileList.length === 0) {
                NotificationManager.error('Please select a file first!', '', 3000);
                return false;
            }
            return true;

        } else if (paymentType == "USDT") {
            if ((formData.upiId || "").trim() === "") {
                setUPIValidationError('Please enter USDT wallet address')
                document.querySelector('.upiid').classList.remove('hidden');
            }
            if ((formData.holderName || "").trim() === "") {
                setHolderValidationError('Please enter holder name')
                document.querySelector('.holder').classList.remove('hidden');
            }
            if ((formData.upiId || "") !== "" && (formData.holderName || "") !== "") {
                return true
            }
            return false;
        } else {
            if ((formData.upiId || "").trim() === "") {
                setUPIValidationError('Please enter upi id')
                document.querySelector('.upiid').classList.remove('hidden');
            }
            if ((formData.holderName || "").trim() === "") {
                setHolderValidationError('Please enter holder name')
                document.querySelector('.holder').classList.remove('hidden');
            }
            if ((formData.upiId || "") !== "" && (formData.holderName || "") !== "") {
                return true
            }
            return false;
        }


    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (paymentType) {

            const formDataToSend = new FormData();

            fileList.forEach((file) => {
                formDataToSend.append('file', file.originFileObj);
            });

            formDataToSend.append('user_id', userInfo?._id);
            formDataToSend.append('site_code', Appconfig.sitecodes);
            formDataToSend.append('accountNo', formData.accountNo);
            formDataToSend.append('accountHolder', formData.accountHolder);
            formDataToSend.append('ifscCode', formData.ifscCode);
            formDataToSend.append('bankName', formData.bankName);
            formDataToSend.append('upiId', formData.upiId);
            formDataToSend.append('holderName', formData.holderName);
            formDataToSend.append('usdtAddress', formData.usdtAddress);
            formDataToSend.append('type', paymentType);

            if (checkValidation()) {

                var config = {
                    method: "post",
                    url: `${Appconfig.apiUrl}paymentMethod/addMethod`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: formDataToSend,
                };

                axios(config)
                    .then(function (response) {
                        if (response.data.result) {
                            NotificationManager.success(response.data.resultMessage, '', 3000);
                            setFormData({
                                accountNo: "",
                                accountHolder: "",
                                ifscCode: "",
                                bankName: "",
                                upiId: "",
                                holderName: ""
                            });
                            setFileList([]);
                            getPaymentDetails();
                            setOpenBanner(false);
                        } else {
                            NotificationManager.error(response.data.resultMessage, '', 3000);
                        }
                        setButton(false);

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        } else {
            NotificationManager.error("Please Select Any Payment Type", '', 3000);

        }
    };

    const getPaymentDetails = () => {

        let site_code = Appconfig.sitecodes;
        let data = JSON.stringify({
            site_code: site_code,
            user_id: userInfo?._id
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}paymentMethod/getPaymentDetails`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    setPatmentMethod(response.data.resultData);
                } else {
                    NotificationManager.error(response.data.resultMessage, '', 3000);
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    };

    useEffect(() => {
        getPaymentDetails();
    }, [])


    return (
        <>
            <NotificationContainer />
            <Modal
                className="payment-method-modal"
                open={openBanner}
                centered
                width={680}
                title={null}
                closable={false}
                destroyOnClose
                maskClosable={!button}
                keyboard={!button}
                onCancel={closeAddMethodModal}
                footer={
                    <div className="payment-modal-footer">
                        <button
                            type="button"
                            className="payment-modal-cancel"
                            disabled={button}
                            onClick={
                                closeAddMethodModal
                            }
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="payment-modal-submit"
                            disabled={button}
                            onClick={handleSubmit}
                        >
                            {button
                                ? "Saving..."
                                : "Add Method"}
                        </button>
                    </div>
                }
            >
                <div className="payment-modal-content">
                    <div className="payment-modal-header">
                        <div>
                            <h2>Add Payment Method</h2>
                            <p>
                                Add bank, UPI, QR code, or USDT
                                payment details
                            </p>
                        </div>

                        <button
                            type="button"
                            className="payment-modal-close"
                            disabled={button}
                            aria-label="Close modal"
                            onClick={closeAddMethodModal}
                        >
                            ×
                        </button>
                    </div>
                    <div className="payment-modal-body">
                        <div className="payment-modal-form">
                            <div className="payment-modal-form-content">
                                {/* Payment Type Selection */}
                                <div className="col-span-12 lg:col-span-6 mb-4">
                                    <label
                                        htmlFor="datasourceSelect"
                                        className="inline-block mb-[.5rem] text-[0.813rem] font-normal leading-normal"
                                    >
                                        Method
                                    </label>
                                    <select
                                        id="paymentType"
                                        name="paymentType"
                                        className="pl-[.95rem] [text-indent:1px] appearance-none block w-full h-[calc(1.5em+.75rem+2px)] px-[.75rem] py-[.375rem] text-[.875rem] font-normal leading-normal text-[#5c6873] border-[1px] border-[solid] border-[#ccc] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] [word-wrap:normal]"
                                        style={{
                                            background:
                                                "#fff url(https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg) right 93% / 8% 12px no-repeat",
                                            backgroundPosition: "right 0% bottom 45%",
                                        }}
                                        onChange={handlePaymentTypeChange}
                                        value={paymentType}
                                    >
                                        <option
                                            className="[text-indent:1px] text-[.875rem] leading-normal text-[#5c6873]"
                                            disabled
                                            value={""}
                                        >
                                            Select Type
                                        </option>
                                        {Appconfig.account_type?.map((type, index) => (
                                            <option
                                                key={index}
                                                className="[text-indent:1px] text-[.875rem] leading-normal text-[#5c6873]"
                                                value={type}
                                            >
                                                {type}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Dynamic Form Fields */}
                                {paymentType === "Bank" ? (
                                    <div id="bank_method">
                                        <h3 className="mb-4 !text-[#23282c] font-medium">Bank Payment Details</h3>
                                        <div className="col-span-12 lg:col-span-12 grid grid-cols-2 gap-4">
                                            <div className="mb-4">
                                                <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="accountNo">
                                                    Account No.
                                                </label>
                                                <Input
                                                    id="accountNo"
                                                    name="accountNo"
                                                    required
                                                    className="antd-password"
                                                    placeholder="Enter Bank Account Number"
                                                    onChange={handleSetFormData}
                                                />
                                                <span className="acnum error-message hidden">
                                                    <div className=''>{AcNumValidationError}</div>
                                                </span>
                                            </div>
                                            <div className="mb-4">
                                                <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="accountHolder">
                                                    Account Holder Name
                                                </label>
                                                <Input
                                                    id="accountHolder"
                                                    name="accountHolder"
                                                    required
                                                    className="antd-password"
                                                    placeholder="Enter Bank Holder Name"
                                                    onChange={handleSetFormData}
                                                />
                                                <span className="acholder error-message hidden">
                                                    <div className=''>{AcHolderValidationError}</div>
                                                </span>
                                            </div>
                                            <div className="mb-4">
                                                <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="ifscCode">
                                                    IFSC Code
                                                </label>
                                                <Input
                                                    id="ifscCode"
                                                    name="ifscCode"
                                                    required
                                                    className="antd-password"
                                                    placeholder="Enter IFSC Code"
                                                    onChange={handleSetFormData}
                                                />
                                                <span className="ifsccode error-message hidden">
                                                    <div className=''>{IfscValidationError}</div>
                                                </span>
                                            </div>
                                            <div className="mb-4">
                                                <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="bankName">
                                                    Bank Name
                                                </label>
                                                <Input
                                                    id="bankName"
                                                    name="bankName"
                                                    required
                                                    className="antd-password"
                                                    placeholder="Enter Bank Name"
                                                    onChange={handleSetFormData}
                                                />
                                                <span className="bankname error-message hidden">
                                                    <div className=''>{BankValidationError}</div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ) : paymentType === "QRCODE" ?
                                    <div id="qr_method">
                                        <h3 className="mb-4 !text-[#23282c] font-medium">
                                            ADD {paymentType}
                                        </h3>
                                        <div className="col-span-12 lg:col-span-12 grid grid-cols-2 gap-4">
                                            <div className="mb-4">
                                                <Upload
                                                    beforeUpload={() => false} // Prevent auto upload
                                                    multiple={false} // Only allow one file at a time; change if needed
                                                    fileList={fileList}
                                                    onChange={handleChange}
                                                >
                                                    <Button icon={<UploadOutlined />}>Select Image</Button>
                                                </Upload>
                                            </div>
                                        </div>
                                    </div>
                                    : paymentType === "USDT" ? (
                                        <div id="usdt_method">
                                            <h3 className="mb-4 !text-[#23282c] font-medium">USDT Payment Details</h3>
                                            <div className="col-span-12 lg:col-span-12 grid grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="usdtAddress">
                                                        USDT Wallet Address
                                                    </label>
                                                    <Input
                                                        id="usdtAddress"
                                                        name="usdtAddress"
                                                        required
                                                        className="antd-password"
                                                        placeholder="Enter USDT Wallet Address"
                                                        onChange={handleSetFormData}
                                                    />
                                                    <span className="upiid error-message hidden">
                                                        <div className=''>{UPIValidationError}</div>
                                                    </span>
                                                </div>
                                                <div className="mb-4">
                                                    <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="holderName">
                                                        Holder Name
                                                    </label>
                                                    <Input
                                                        id="holderName"
                                                        name="holderName"
                                                        required
                                                        className="antd-password"
                                                        placeholder="Enter Holder Name"
                                                        onChange={handleSetFormData}
                                                    />
                                                    <span className="holder error-message hidden ">
                                                        <div className=''>{HolderValidationError}</div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : paymentType ? (
                                        <div id="other_method">
                                            <h3 className="mb-4 !text-[#23282c] font-medium">
                                                {paymentType} Payment Details
                                            </h3>
                                            <div className="col-span-12 lg:col-span-12 grid grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <label className="inline-block mb-[.5rem] !text-[#23282c]" htmlFor="upiId">
                                                        {paymentType} ID
                                                    </label>
                                                    <Input
                                                        id="upiId"
                                                        name="upiId"
                                                        required
                                                        className="antd-password"
                                                        placeholder={`Enter ${paymentType} ID`}
                                                        onChange={handleSetFormData}
                                                    />
                                                    <span className="upiid error-message hidden">
                                                        <div className=''>{UPIValidationError}</div>
                                                    </span>
                                                </div>
                                                <div className="mb-4">
                                                    <label
                                                        className="inline-block mb-[.5rem] !text-[#23282c]"
                                                        htmlFor="holderName"
                                                    >
                                                        {paymentType} Holder Name
                                                    </label>
                                                    <Input
                                                        id="holderName"
                                                        name="holderName"
                                                        required
                                                        className="antd-password"
                                                        placeholder={`Enter ${paymentType} Holder Name`}
                                                        onChange={handleSetFormData}
                                                    />
                                                    <span className="holder error-message hidden ">
                                                        <div className=''>{HolderValidationError}</div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                            </div>
                        </div>
                    </div>

                </div>
            </Modal>

            <main className="payment-methods-page">
                <section className="payment-methods-card">
                    <div className="payment-methods-heading">
                        <div>
                            <span className="payment-heading-icon">
                                ₹
                            </span>

                            <div>
                                <h1>Payment Methods</h1>

                                <p>
                                    Manage bank, UPI, QR code
                                    and USDT payment details
                                </p>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="payment-add-button"
                            onClick={
                                openAddMethodModal
                            }
                        >
                            <span aria-hidden="true">
                                +
                            </span>

                            Add Method
                        </button>
                    </div>

                    <div className="payment-methods-summary">
                        <div>
                            <span>Total Methods</span>

                            <strong>
                                {paymentMethod.length}
                            </strong>
                        </div>

                        <div>
                            <span>Active</span>

                            <strong>
                                {
                                    paymentMethod.filter(
                                        (method) =>
                                            method?.status ===
                                            "Active"
                                    ).length
                                }
                            </strong>
                        </div>

                        <div>
                            <span>Inactive</span>

                            <strong>
                                {
                                    paymentMethod.filter(
                                        (method) =>
                                            method?.status !==
                                            "Active"
                                    ).length
                                }
                            </strong>
                        </div>
                    </div>

                    <div className="payment-methods-table-wrapper">
                        <Table
                            rowKey={(record) =>
                                record?._id
                            }
                            columns={columns}
                            dataSource={paymentMethod}
                            className="payment-methods-table"
                            pagination={false}
                            locale={{
                                emptyText:
                                    "No payment methods found.",
                            }}
                            scroll={{
                                x: 900,
                            }}
                        />
                    </div>
                </section>
            </main>

        </>
    )
}


export default PaymentMethods;
